(function(){
    'use strict'

    angular.module('app.variables')
    .factory('VariablesService', VariablesService);

    VariablesService.$inject = ['$http', '$q', 'apiSettings'];

    function VariablesService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/variables';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(variableId){

            var url = apiSettings.apiBaseUrl + 'api/variables/' + variableId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(variable){

            variable.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/variables',  
                method: 'POST',  
                data: variable
            });  
            return response;
        };

        function update(variable){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/variables',  
                method: 'PUT',  
                data: variable
            });  
            return response;
        };

        function remove(variable){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/variables',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: variable
            });  
            return response;
        };

    };

})();